import { render } from "./MarkdownView.vue?vue&type=template&id=fb47ba8c&ts=true"
import script from "./MarkdownView.vue?vue&type=script&lang=ts"
export * from "./MarkdownView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__